"use client";

import { ReCaptchaContext } from "next-recaptcha-v3";
import { ReactNode } from "react";

export default function DesignCaptcha({ children }: { children: ReactNode }) {
  return (
    <ReCaptchaContext.Provider
      value={{
        reCaptchaKey: "local-design",
        loaded: true,
        error: false,
        grecaptcha: { execute: async () => "local-design" } as any,
      }}
    >
      {children}
    </ReCaptchaContext.Provider>
  );
}
